import { render } from "./SpecificationsProduct.vue?vue&type=template&id=85a9872e&scoped=true"
import script from "./SpecificationsProduct.vue?vue&type=script&lang=js"
export * from "./SpecificationsProduct.vue?vue&type=script&lang=js"

import "./SpecificationsProduct.vue?vue&type=style&index=0&id=85a9872e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a9872e"]])

export default __exports__